import { Component, Inject } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { filter } from 'rxjs';
import {
  L10N_LOCALE,
  L10nLocale,
  L10nTranslationModule,
  L10nTranslationService,
} from 'angular-l10n';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ToastHandlerService } from '../../services/other/tostHandler.service';
import { ToastModel } from '../../models/other/toastHandler.model';

@Component({
  selector: 'supplierDB-registration-page-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    L10nTranslationModule,
    ToastModule,
  ],
  templateUrl: './page-layout.component.html',
  styleUrl: './page-layout.component.scss',
})
export class PageLayoutComponent {
  headerText: string = '';

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastHandlerService: ToastHandlerService,
    private messageService: MessageService,
    private translationService: L10nTranslationService
  ) {
    // listen for send messages
    this.toastHandlerService
      .getToastEvent()
      .subscribe((msgInfo: ToastModel) => this.messageService.add(msgInfo));
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateHeaderText();
      });
  }

  /**
   * Updates the header text based on the current route's data.
   *
   * @remarks
   * This function retrieves the first child route of the activated route and subscribes to its data.
   * If the data contains a 'headerText' property, it updates the `headerText` property of the component.
   * If the 'headerText' property is not present, it defaults to 'Welcome to u-tender'.
   * @returns {void}
   */
  public updateHeaderText(): void {
    const route = this.activatedRoute.firstChild;
    if (route) {
      route.data.subscribe((data) => {
        this.headerText =
          data['headerText'] ||
          this.translationService.translate('GENERAL.WELCOME');
      });
    }
  }
}
